import React from "react";
import { Helmet } from "react-helmet-async";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useLanguage } from "../contexts/LanguageContext";

export default function PrivacyPage() {
  const { lang } = useLanguage();
  const isTR = lang === "tr";

  return (
    <div className="min-h-screen bg-cream text-ink" data-testid="privacy-page">
      <Helmet>
        <title>{isTR ? "Gizlilik Politikası — Yastık Medya" : "Privacy Policy — Yastık Medya"}</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Header />
      <main className="container-page py-20 max-w-3xl">
        <h1 className="font-display text-display-2 font-bold text-ink mb-8">
          {isTR ? "Gizlilik Politikası" : "Privacy Policy"}
        </h1>
        <div className="prose prose-ink max-w-none space-y-6 text-ink/80 leading-relaxed">
          <p className="text-ink/50 text-sm">{isTR ? "Son güncelleme: Mayıs 2026" : "Last updated: May 2026"}</p>

          <section>
            <h2 className="font-display text-h2 font-semibold text-ink mt-8 mb-3">
              {isTR ? "1. Toplanan Veriler" : "1. Data Collected"}
            </h2>
            <p>
              {isTR
                ? "Yastık Medya olarak web sitemizi ziyaret ettiğinizde; ad, soyad, e-posta adresi ve telefon numarası gibi iletişim bilgilerinizi yalnızca sizin rızanızla toplarız. Bu veriler yalnızca size hizmet sunabilmek amacıyla kullanılır."
                : "When you visit our website, we may collect contact information such as your name, email address, and phone number, only with your consent. This data is used solely to provide you with our services."}
            </p>
          </section>

          <section>
            <h2 className="font-display text-h2 font-semibold text-ink mt-8 mb-3">
              {isTR ? "2. Veri Kullanımı" : "2. Use of Data"}
            </h2>
            <p>
              {isTR
                ? "Topladığımız veriler; teklif hazırlamak, hizmet sözleşmesi kurmak ve müşteri ilişkilerini yönetmek amacıyla kullanılır. Verileriniz hiçbir koşulda üçüncü şahıslarla paylaşılmaz veya satılmaz."
                : "Collected data is used to prepare proposals, establish service contracts, and manage customer relationships. Your data is never shared with or sold to third parties."}
            </p>
          </section>

          <section>
            <h2 className="font-display text-h2 font-semibold text-ink mt-8 mb-3">
              {isTR ? "3. Çerezler" : "3. Cookies"}
            </h2>
            <p>
              {isTR
                ? "Sitemiz analitik ve performans ölçümü için çerezler kullanabilir. Tarayıcı ayarlarınızdan çerezleri devre dışı bırakabilirsiniz."
                : "Our site may use cookies for analytics and performance measurement. You can disable cookies through your browser settings."}
            </p>
          </section>

          <section>
            <h2 className="font-display text-h2 font-semibold text-ink mt-8 mb-3">
              {isTR ? "4. İletişim" : "4. Contact"}
            </h2>
            <p>
              {isTR
                ? "Gizlilik politikamıza ilişkin sorularınız için "
                : "For questions about our privacy policy, please contact us at "}
              <a href="mailto:merhaba@yastikmedya.com" className="text-brand-pink hover:underline">
                merhaba@yastikmedya.com
              </a>
              {isTR ? " adresinden bize ulaşabilirsiniz." : "."}
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
